<template>
  <div>
    <a-button v-if="!$userIsInrol('Query')" @click="showModal">Crear Persona</a-button>
    <a-modal title="Registrar Persona"
             :visible="visible"
             @ok="registrarPersona"
             @cancel="cancelar"
             :confirmLoading="loading"
             style="top: 20px;">
      <a-form :form="form" @submit="registrarPersona">
        <a-form-item v-bind="fiOptions" :label="$t('Identificación')">
          <a-input placeholder="Identificación"
                   class="ant-uppercase"
                   v-decorator="['identificacion', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
        </a-form-item>
        <g-dropdown endpoint="hierarchy_lookup"
                    :label="$t('Tipo Identificación')"
                    :decorator="['tipo_identificacion', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                    :formItemConfig="fiOptions"
                    :params="{h_lookup_type: 'TIPO_DOCUMENTO', use_code: true}"></g-dropdown>
        <a-form-item v-bind="fiOptions" label="Nombre">
          <a-input placeholder="Nombre"
                   class="ant-uppercase"
                   v-decorator="['nombre', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
        </a-form-item>
        <a-form-item v-bind="fiOptions" :label="$t('Primer Apellido')">
          <a-input placeholder="Primer Apellido"
                   class="ant-uppercase"
                   v-decorator="['primer_apellido', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
        </a-form-item>
        <a-form-item v-bind="fiOptions" :label="$t('Segundo Apellido')">
          <a-input placeholder="Segundo Apellido"
                   class="ant-uppercase"
                   v-decorator="['segundo_apellido']"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        visible: false,
        loading: false,
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        form: this.$form.createForm(this, {
          name: 'biodataRegistrarPersona'
        })
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      showModal () {
        this.visible = true
        this.form.resetFields()
      },
      registrarPersona () {
        this.loading = true
        this.form.validateFields((err, values) => {
          if (!err) {
            this.httpClient.getInstance().post('biodata/registrar_persona', values)
              .then(response => {
                Mensajes.success('Correcto', 'Se registró correctamente la persona.')
                this.visible = false
                this.$emit('success', response.data)
              })
              .catch(error => {
                let result = 'No fue posible registrar la persona. Contacte al administrador.'
                if (!JsUtils.isEmpty(error.response)) {
                  result = JsUtils.isEmpty(error.response.data) ? 'No fue posible registrar la persona.' : error.response.data.message
                }
                Mensajes.error('Error', result)
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      cancelar () {
        if (this.loading) return
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataCrearPersona.vue